import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001/api';

export const getOffers = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}/offers/list`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('authToken')}`,
      },
    });
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || error.message;
  }
};

export const getOfferById = async (offerId) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/offers/${offerId}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('authToken')}`,
      },
    });
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || error.message;
  }
};

export const acceptOffer = async (offerId) => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/offers/${offerId}/accept`,
      {},
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('authToken')}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || error.message;
  }
};

export const declineOffer = async (offerId, reason) => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/offers/${offerId}/decline`,
      { reason },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('authToken')}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || error.message;
  }
};

export const updateDOJ = async (offerId, newDOJ) => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/offers/${offerId}/update-doj`,
      { dateOfJoining: newDOJ },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('authToken')}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || error.message;
  }
};

export const withdrawOffer = async (offerId, reason) => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/offers/${offerId}/withdraw`,
      { reason },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('authToken')}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || error.message;
  }
};
